<script setup>
</script>
<template>
  <button type="button" role="button" v-bind="$attrs">
    <slot />
  </button>
</template>
<style lang="scss" scoped>
button {
    text-align: center;
    font-size: 1rem;
    font-weight: 600;
    flex: 1 1 100%;
    margin: 0;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    min-height: 3rem;
    gap: 0.25em;

    &.btn-primary {
        color: white;
        background-color: var(--c-primary);
    }
    &:disabled,
    &.btn-inactive {
        opacity: 0.5;
        background-color: #9b9b9b;
    }
}
</style>